import _typeof from "@babel/runtime/helpers/typeof";
var win = global.window;
var doc = global.document;
var disableClickHandler = false;

var disable = function disable(isDisabled) {
  disableClickHandler = isDisabled;
};

var runArrayOfFunctions = function runArrayOfFunctions(arrayOfFunctions, clickEvent, subscribedElement) {
  if (arrayOfFunctions.length) {
    arrayOfFunctions.forEach(function (pushedFunctions) {
      return pushedFunctions(clickEvent, subscribedElement);
    });
  }
};
/**
 * Callback for anchor and buttons.
 * @param e The click event
 */


var anchorOrButtonEvents = [];

var anchorOrButtonCallback = function anchorOrButtonCallback(clickEvent, subscribedElement) {
  runArrayOfFunctions(anchorOrButtonEvents, clickEvent, subscribedElement);
};
/**
 * Callback for SELECT type.
 */


var selectEvents = [];

var selectCallback = function selectCallback(clickEvent, subscribedElement) {
  runArrayOfFunctions(selectEvents, clickEvent, subscribedElement);
};
/**
 * Callback for INPUT type.
 */


var inputEvents = [];

var inputCallback = function inputCallback(clickEvent, subscribedElement) {
  runArrayOfFunctions(inputEvents, clickEvent, subscribedElement);
};
/**
 * Callback for FORM type.
 */


var formEvents = [];

var formCallback = function formCallback(formEvent, subscribedElement) {
  runArrayOfFunctions(formEvents, formEvent, subscribedElement);
};

var getElementFromEvent = function getElementFromEvent(e) {
  // Polyfill for Selects
  var evt = e || win.event;
  var element = evt.target || evt.srcElement;
  return element;
};
/**
 * Callback configuration object. Contains the type of element and
 * that element callback.
 * @type {[*]}
 */


var callbackConfig = [{
  types: ['A', 'BUTTON'],
  cb: anchorOrButtonCallback
}, {
  types: ['SELECT'],
  cb: selectCallback
}, {
  types: ['INPUT'],
  cb: inputCallback
}, {
  types: ['FORM'],
  cb: formCallback
}
/* Add more types here */
];
var eventSubscribers = [];
/**
 * This function configures all of the element type callbacks.
 * @param callbacksConfig The
 * @returns {Function} Return the document's click handler.
 */

var createHandlers = function createHandlers(callbacksConfig) {
  return function (event) {
    var evt = event || win.event;
    var element = evt.target || evt.srcElement;
    var _element = element,
        tagName = _element.tagName;

    var elementCallBack = function elementCallBack(el) {
      var matchedCallBackConfig = false;

      if (_typeof(el) === 'object') {
        callbacksConfig.forEach(function (action) {
          if (action.types.some(function (type) {
            return type === tagName;
          })) {
            // call the configured callback
            action.cb(evt, el);
            matchedCallBackConfig = true;
          }
        });
      }

      return matchedCallBackConfig;
    };
    /*
     * Evaluate Clicked Element,
     * If no Callback Actions are found,
     * traverse up dom and evaluate parents until parent is null or a callback action is found.
     */


    var elementHasCallBack = elementCallBack(element);

    while (element && !elementHasCallBack) {
      if (!elementHasCallBack) {
        element = element.parentElement;

        if (element) {
          tagName = element.tagName || null;
        } else {
          tagName = null;
        }

        elementHasCallBack = elementCallBack(element);
      }
    }
  };
};

if (doc && !disableClickHandler) {
  doc.addEventListener('DOMContentLoaded', function () {
    doc.addEventListener('click', function (clickEvent) {
      eventSubscribers.forEach(function (subscriber) {
        subscriber(clickEvent);
      });
    }, false);
    doc.addEventListener('submit', function (submitEvent) {
      eventSubscribers.forEach(function (subscriber) {
        subscriber(submitEvent);
      });
    }, false);
  });
}
/**
 * Configure the global event handler.
 */


var eventHandler = createHandlers(callbackConfig); // Subscribe to Events

eventSubscribers.push(eventHandler);
export { disable, eventHandler, inputEvents, selectEvents, anchorOrButtonEvents, formEvents, getElementFromEvent };
//# sourceMappingURL=index.js.map